let obj = {
    username: '',
    name: '',
    email: '',
    role: '',
    password: '',
    password_confirmation: '',
}
export default obj;